import { useMemo } from 'react'
import { useDateFormatter } from '../../../../../generic/hooks/useDateFormatter'
import { useSmartTranslation } from '../../../../../generic/hooks/useSmartTranslation'

// Story 100 (S106, RN33/RN33.1/CA7): columns for the "External jobs" tab of the "All Planned Jobs"
// modal. SOLELY VISIBILITY -- unlike `useJobColumns` (the other 5 tabs), this hook takes NO
// callbacks (no onStatusChange/onShowDetails/onOpenQualityIncidence) because there is nothing to
// trigger from here: no dispatch, no return, no start, no join (those actions live exclusively in
// the External jobs widget, Lote 1) and no quality indicator (RN33.1/DN-31, S153) -- by omission,
// not by a hidden/disabled flag.
const SITUATION_LABELS = {
  PENDING_DISPATCH: 'Pending dispatch',
  DISPATCHED: 'Dispatched',
  RETURNED: 'Returned'
}

const useExternalCircuitTabColumns = () => {
  const { formatDateTime } = useDateFormatter()
  const { t_ } = useSmartTranslation()

  return useMemo(() => [
    {
      name: t_('Fabrication order'),
      field: 'fabricationOrder',
      readOnly: true,
      render: (row) => row.fabricationOrder?.fabricationOrder ?? ''
    },
    {
      name: t_('Job'),
      field: 'job',
      readOnly: true,
      render: (row) => row.job?.name ?? ''
    },
    {
      name: t_('Technology'),
      field: 'technology',
      readOnly: true,
      render: (row) => row.technology ?? ''
    },
    {
      // Reuses the existing generic "Status" header (the population labels themselves --
      // "Pending dispatch"/"Dispatched"/"Returned" -- already exist in the catalog since Lote 1).
      name: t_('Status'),
      field: 'situation',
      readOnly: true,
      render: (row) => (SITUATION_LABELS[row.situation] ? t_(SITUATION_LABELS[row.situation]) : '')
    },
    {
      name: t_('Promised return'),
      field: 'promisedReturn',
      readOnly: true,
      render: (row) => (row.promisedReturnDate ? formatDateTime(row.promisedReturnDate) : (row.promisedReturnDurationLabel ?? ''))
    },
    {
      name: t_('Actual dispatch'),
      field: 'actualDispatch',
      type: 'datetime',
      readOnly: true,
      render: (row) => (row.actualDispatch ? formatDateTime(row.actualDispatch) : '')
    },
    {
      name: t_('Actual return'),
      field: 'actualReturn',
      type: 'datetime',
      readOnly: true,
      render: (row) => (row.actualReturn ? formatDateTime(row.actualReturn) : '')
    }
  ], [formatDateTime, t_])
}

export default useExternalCircuitTabColumns
